import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";

// Public site
import HomePage from "./pages/HomePage";
import AanbodPage from "./pages/AanbodPage";
import DetailPage from "./pages/DetailPage";
import OverOnsPage from "./pages/OverOnsPage";
import ServicesPage from "./pages/ServicesPage";
import EventsPage from "./pages/EventsPage";
import ContactPage from "./pages/ContactPage";
import StoriesListPage from "./pages/StoriesListPage";
import StoryDetailPage from "./pages/StoryDetailPage";
import NotFoundPage from "./pages/NotFoundPage";

// Admin
import { AuthProvider } from "./admin/AuthContext";
import ProtectedRoute from "./admin/ProtectedRoute";
import AdminLayout from "./admin/AdminLayout";
import LoginPage from "./admin/pages/LoginPage";
import DashboardPage from "./admin/pages/DashboardPage";
import PagesListPage from "./admin/pages/PagesListPage";
import PageEditorPage from "./admin/pages/PageEditorPage";
import BlocksPage from "./admin/pages/BlocksPage";
import StoriesAdminListPage from "./admin/pages/StoriesListPage";
import StoryEditorPage from "./admin/pages/StoryEditorPage";
import MediaPage from "./admin/pages/MediaPage";
import SettingsPage from "./admin/pages/SettingsPage";
import AccountPage from "./admin/pages/AccountPage";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            {/* Public site */}
            <Route path="/" element={<HomePage />} />
            <Route path="/aanbod" element={<AanbodPage />} />
            <Route path="/aanbod/:slug" element={<DetailPage />} />
            <Route path="/over-ons" element={<OverOnsPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/events" element={<EventsPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/verhalen" element={<StoriesListPage />} />
            <Route path="/verhalen/:slug" element={<StoryDetailPage />} />

            {/* Admin */}
            <Route path="/admin/login" element={<LoginPage />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<DashboardPage />} />
              <Route path="pages" element={<PagesListPage />} />
              <Route path="pages/:id" element={<PageEditorPage />} />
              <Route path="blocks" element={<BlocksPage />} />
              <Route path="stories" element={<StoriesAdminListPage />} />
              <Route path="stories/:id" element={<StoryEditorPage />} />
              <Route path="media" element={<MediaPage />} />
              <Route path="settings" element={<SettingsPage />} />
              <Route path="account" element={<AccountPage />} />
            </Route>

            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: "#121214",
            border: "1px solid rgba(212,175,55,0.3)",
            color: "#FAFAFA",
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
